import { api } from '../../../system/api'

export default {
    deleteBagLastmile: (bagId, bagLastMileId) => api.put(`bags/${bagId}/bag-packings/${bagLastMileId}/delete-bag-last-mile`, {}),
}
